import { getFreshIdToken } from "./getFreshIdToken";
import { getStoredIdToken } from "./tokenStore";

/**
 * `fetch` wrapper that injects a freshly-refreshed Cognito ID token as a
 * `Bearer` Authorization header at call time.
 *
 * Use this for the fetch-based services (chat stream, conversation history,
 * content, onboarding stream, etc.) so they pick up silent token rotation
 * without reading the token from React state. The axios call sites get the
 * same behaviour from the request interceptor in setupAxiosAuthInterceptor.
 *
 * @param input  Same as the native fetch input.
 * @param init   Same as the native fetch init; any Authorization header here is
 *               overwritten with the fresh token.
 * @param seedToken Optional token to seed the freshness check (e.g. the token a
 *               caller already had). Defaults to the module token store.
 */
export async function authedFetch(
  input: RequestInfo | URL,
  init: RequestInit = {},
  seedToken?: string
): Promise<Response> {
  const fresh = await getFreshIdToken(seedToken ?? getStoredIdToken());
  const headers = new Headers(init.headers || {});
  if (fresh) {
    headers.set("Authorization", `Bearer ${fresh}`);
  }
  return fetch(input, { ...init, headers });
}
